export const columnHeader = [
  {
    key: 'name', name: 'Team Member', width: "50%",
  },
  {
    key: 'status', name: 'Status', width: "10%",
  },
  {
    key: 'role', name: 'Roles', width: "40%",
  },
];